module.exports = __webpack_public_path__ + "img/intro_3.8ee8a4f5.jpg";